"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledNextLoader = exports.StyledSchedulingHelpBanner = exports.StyledSuggestedProviderHeaderText = exports.SuggestProviderContainer = exports.GxNextQuestions = exports.GxConditionalQuestions = exports.GxQuestions = exports.FieldFocusWrapper = exports.NextBtnContainer = exports.BannerContainer = exports.Container = void 0;
const ui_theme_1 = require("@kyruus/ui-theme");
const styled_1 = __importDefault(require("@emotion/styled"));
const framer_motion_1 = require("framer-motion");
const breakpoints_1 = require("../../lib/constants/breakpoints");
const gx_1 = require("@kyruus/gx");
const Banners_1 = require("../Banners");
const NextLoader_1 = __importDefault(require("./NextLoader"));
exports.Container = (0, styled_1.default)('div') `
  h4 {
    margin: 0;
    padding: 0;
    margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
    font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  }
`;
exports.BannerContainer = (0, styled_1.default)('div') `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
`;
exports.NextBtnContainer = (0, styled_1.default)(framer_motion_1.motion.div) `
  display: inline-block;
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
  button {
    width: ${breakpoints_1.BUTTON_WIDTH};
  }
`;
exports.FieldFocusWrapper = styled_1.default.div `
  & select:focus /* simpleSelect */ {
    outline-color: ${(0, ui_theme_1.fromTheme)('color_link')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: solid;
    outline-offset: 0px;
  }
`;
exports.GxQuestions = styled_1.default.div ``;
exports.GxConditionalQuestions = styled_1.default.div `
  padding-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.GxNextQuestions = (0, styled_1.default)(gx_1.GxNext) ``;
exports.SuggestProviderContainer = styled_1.default.div `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  ${(props) => !props.aboveMd &&
    `& > div > div {
        flex-basis: 100%;
      }
      overflow: hidden;
    `}
`;
exports.StyledSuggestedProviderHeaderText = styled_1.default.div `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_5')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
`;
exports.StyledSchedulingHelpBanner = (0, styled_1.default)(Banners_1.SchedulingHelpBanner) `
  margin-top: ${(props) => props.isErrorBannerRendered ? (0, ui_theme_1.fromTheme)('spacing_large') : '0px'};
`;
exports.StyledNextLoader = (0, styled_1.default)(NextLoader_1.default) `
  margin-left: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  margin-bottom: ${(props) => props.isMobileLoader ? (0, ui_theme_1.fromTheme)('spacing_large') : '0px'};
`;
//# sourceMappingURL=styles.js.map